import React from "react";
import { Text, Box } from "@chakra-ui/core";
import { string } from "prop-types";
import colors from "../../utils/colors";
import { supportedColorValues } from "../../utils/propTypes";

// Cloned from https://github.com/chakra-ui/chakra-ui/blob/develop/packages/progress/src/circular-progress.tsx
// because Chakra doesn't support colors correctly on this component
function PercentWheel({
  chanceElevated = 0,
  offsetPercent = 0,
  width = "150px",
  strokeColor = colors.redAlpha,
  textColor = "red",
  ...rest
}) {
  const innerRadius = 65;
  const circumference = 2 * Math.PI * innerRadius;
  const determinant = (chanceElevated / 100) * circumference;
  const strokeDashArray = `${determinant} ${circumference - determinant}`;
  // offsetRadians is a fraction of the circumference. Use negative sign
  // because we want to move clockwise on the circle.
  const offsetRadians = -(offsetPercent / 100) * circumference;

  return (
    <Box width={width} position="relative" {...rest}>
      <svg viewBox="0 0 150 150">
        <circle
          // This is the track
          cx="75"
          cy="75"
          r="75"
          fill={colors.greyLight}
          style={{ boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.05)" }}
        />
        <circle
          // This is the "progress bar"
          cx="75"
          cy="75"
          r="65"
          // Aligns the start of the stroke dash with "12 o' clock" plus
          // an additional offset (if any)
          strokeDashoffset={circumference / 4 + offsetRadians}
          strokeDasharray={strokeDashArray}
          stroke={strokeColor}
          strokeWidth={20}
        />
        <circle
          // This is the "center"
          cx="75"
          cy="75"
          fill={colors.greyscale1}
          // For some reason, without this we get a very very faint aliasing on the
          // border of this circle.
          stroke={colors.greyscale1}
          r="65"
        />
      </svg>
      <Text
        color={textColor}
        fontSize="18px"
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        margin="0"
      >{`${chanceElevated}%`}</Text>
    </Box>
  );
}

PercentWheel.propTypes = {
  chanceElevated: string.isRequired,
  offsetPercent: string,
  width: string,
  strokeColor: supportedColorValues,
  textColor: string,
};

export default PercentWheel;
